var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollegeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.516766 4.16524H13.4455C13.748 4.16524 13.9748 3.94761 13.9748 3.65743C13.9748 3.4398 13.8488 3.27053 13.6472 3.19798L7.22058 0.0544081C7.06937 -0.018136 6.89295 -0.018136 6.74174 0.0544081L0.289946 3.19798C0.0631249 3.29471 -0.0376843 3.53652 0.0127203 3.77834C0.0883273 3.99597 0.264743 4.16524 0.516766 4.16524ZM6.99376 1.09421L11.2277 3.14962H2.75977L6.99376 1.09421ZM13.4455 10.9844H12.4123V5.32594C12.4123 5.03577 12.1854 4.81814 11.883 4.81814C11.5806 4.81814 11.3538 5.03577 11.3538 5.32594V10.9844H9.13596V5.32594C9.13596 5.03577 8.90913 4.81814 8.60671 4.81814C8.32948 4.81814 8.07746 5.03577 8.07746 5.32594V10.9844H5.85966V5.32594C5.85966 5.03577 5.63283 4.81814 5.33041 4.81814C5.02798 4.81814 4.80116 5.03577 4.80116 5.32594V10.9844H2.60856V5.32594C2.60856 5.03577 2.38174 4.81814 2.07931 4.81814C1.77688 4.81814 1.57526 5.03577 1.57526 5.32594V10.9844H0.541969C0.239541 10.9844 0.0127203 11.202 0.0127203 11.4922C0.0127203 11.7824 0.239541 12 0.541969 12H13.4708C13.7732 12 14 11.7824 14 11.4922C14 11.202 13.748 10.9844 13.4455 10.9844Z",
    fill: "#F49FB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeIcon);
export default __webpack_public_path__ + "static/media/college-icon.4de3232e0214612713ee449ceb20d9be.svg";
export { ForwardRef as ReactComponent };